// HealthTimeline.jsx — Horizontal scrollable clinical timeline
import s from './shared.module.css';

const defaultEvents = [
  { icon: '👧', label: 'Menarche', sub: 'Age 13', done: true },
  { icon: '📋', label: 'Irregular Periods', sub: 'Age 19', done: true },
  { icon: '⚕️', label: 'PCOS Diagnosis', sub: '2020', done: true },
  { icon: '💊', label: 'Started Contraception', sub: '2021', done: true },
  { icon: '🚫', label: 'Stopped Contraception', sub: 'Jan 2024', done: true },
  { icon: '🌸', label: 'Preconception Journey', sub: 'Mar 2024', active: true },
  { icon: '🤰', label: 'Planned Pregnancy', sub: '(Upcoming)', muted: true },
];

export default function HealthTimeline({ events = defaultEvents }) {
  return (
    <div className={s.timeline}>
      {events.map((ev, i) => (
        <div key={i} className={s.timelineItem}>
          {/* connector line (not for last) */}
          {i < events.length - 1 && (
            <div className={s.timelineLine} style={{
              background: ev.done ? 'var(--ava-color-primary-300)' : 'var(--ava-color-gray-300)'
            }} />
          )}
          <div className={`${s.timelineDot} ${ev.active ? s.timelineDotActive : ''}`}
            style={{
              background: ev.muted ? 'var(--ava-color-gray-200)' : ev.done && !ev.active ? 'var(--ava-color-primary-100)' : undefined,
              border: ev.muted ? '2px dashed var(--ava-color-gray-300)' : undefined,
              color: ev.muted ? 'var(--ava-color-caption)' : undefined,
            }}
          >
            {ev.icon}
          </div>
          <p className={s.timelineLabel} style={{ color: ev.muted ? 'var(--ava-color-caption)' : ev.active ? 'var(--ava-color-primary-700)' : undefined }}>
            {ev.label}
          </p>
          <p className={s.timelineSub}>{ev.sub}</p>
        </div>
      ))}
    </div>
  );
}